import React from 'react';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import config from '../../utility/config';
import Button from '../Button';
import { useAuthContext } from '../../contexts/AuthContext/AuthContext';
import LoadingCircle from '../LoadingCircle/index';
import './SocialLogins.scss';

const { googleClientId, fbAppId } = config;

const SocialLogins = ({ isSignup }) => {
  const { isLoading, handleSocialAuth, socialLoginError } = useAuthContext();
  const className = 'c-SocialLogins';

  const socialBtnClass = `${className}__social-btn-wrapper`;
  const googleBtnClass = `${socialBtnClass} ${socialBtnClass}--google`;
  const fbBtnClass = `${socialBtnClass} ${socialBtnClass}--facebook`;

  return (
    <div className={className}>
      {isLoading && <LoadingCircle />}
      {socialLoginError && (
        <p className={`${className}__err-msg`}>{socialLoginError}</p>
      )}
      {/* Facebook Login Btn */}
      {fbAppId && (
        <FacebookLogin
          appId={fbAppId}
          fields="name,first_name,last_name,email,picture.type(large)"
          autoLoad={false}
          disableMobileRedirect={true}
          callback={(res) => handleSocialAuth(res, 'facebook')}
          render={(renderProps) => {
            const { onClick } = renderProps;
            return (
              <div className={fbBtnClass}>
                <Button fluid onClick={onClick}>
                  {isSignup
                    ? 'Sign up with Facebook'
                    : 'Continue with Facebook'}
                </Button>
              </div>
            );
          }}
        />
      )}

      {/* Google Login Button */}
      {googleClientId && (
        <GoogleLogin
          clientId={googleClientId}
          render={({ onClick }) => (
            <div className={googleBtnClass}>
              <Button fluid onClick={onClick}>
                {isSignup ? 'Sign up with Google' : 'Continue with Google'}
              </Button>
            </div>
          )}
          onSuccess={(res) => handleSocialAuth(res, 'google')}
          onFailure={(res) => handleSocialAuth(res, 'google')}
          cookiePolicy={'single_host_origin'}
          autoLoad={false}
        />
      )}
    </div>
  );
};

export default SocialLogins;
